export const CRX_INSTALL_MODAL_ID = "-KXvdcCjv7CkiMVASqH7";
export const CHROME_INSTALL_MODAL_ID = "-KYGGfDfHu3Lm0BgsPE5";
